import React, { MutableRefObject, SetStateAction, useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useAfterPaintEffect, useAppSelector } from '../app/hooks';
import { appendMonth, goToNextMonth, goToPreviousMonth } from '../features/calendar/calendar-slice';
import { useAppDispatch } from '../app/store';
import { getMonthsInRange } from '../helpers/date-helpers';
import { useIsDirectionOutOfRange } from '../app/is-direction-out-of-range-hook';
import { SvgIcon } from './svg-icon';

export const MonthPagination = () => {
    const dispatch = useAppDispatch();
    const appendMonths = useAppSelector(state => state.calendar.appendMonths);
    const { loadMoreEventsButtonText, previousMonthButtonText, nextMonthButtonText } = useAppSelector(state => state.settings);
    const eventsAreLoading = useAppSelector(state => state.calendar.eventsAreLoading);

    const [nextOutOfRange, prevOutOfRange] = useIsDirectionOutOfRange();

    return (
        <div className="ace-cal-pagination">
            {
                appendMonths ?
                    <button type="button" className="btn btn-load-more" onClick={(e) => dispatch(appendMonth())} disabled={eventsAreLoading || nextOutOfRange}>{loadMoreEventsButtonText}</button>
                    :
                    <div className="flex-between">
                        <button type="button" className="btn-primary" onClick={(e) => dispatch(goToPreviousMonth())} disabled={eventsAreLoading || prevOutOfRange}>
                            <SvgIcon iconId="arrow-left" />
                            <span>{previousMonthButtonText}</span>
                        </button>
                        <button type="button" className="btn-primary" onClick={(e) => dispatch(goToNextMonth())} disabled={eventsAreLoading || nextOutOfRange}>
                            <span>{nextMonthButtonText}</span>
                            <SvgIcon iconId="arrow-right" />
                        </button>
                    </div>
            }
        </div>
    );
}